import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import {
    Box, Button, Collapse, FormControl, IconButton, InputLabel, MenuItem,
    Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    TextField, Typography, Menu, ListItemIcon, ListItemText, Pagination, Checkbox, FormControlLabel,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
  } from '@mui/material';
import { ExpandMore, ExpandLess, Search, History, MoreVert, Add, Edit, List } from '@mui/icons-material';
import Navbar from '../Layouts/Navbar';
import Snackbar from '@mui/material/Snackbar';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import MuiAlert from '@mui/material/Alert';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';  
import HistoriqueModal from './HistoriqueModal';
import DeleteIcon from '@mui/icons-material/Delete';
import AddModal from './AddModal';
import UpdateModal from './UpdateModal';
import { Link } from 'react-router-dom';



export default function VehiculeTable() {
  const [openhis, setOpenHis] = useState(false);
  const handleOpenHis = () => setOpenHis(true);
  const handleCloseHis = () => setOpenHis(false);

  const [openadd, setOpenAdd] = useState(false);
  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);
  
  // State for loading vehicles
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [openupd, setOpenUpd] = useState(false);
  const [selectedVehicleId, setSelectedVehicleId] = useState(null);
  
  // State for delete confirmation dialogs
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openBulkDeleteDialog, setOpenBulkDeleteDialog] = useState(false);
  
  const handleOpenDeleteDialog = () => {
    // Ne pas fermer le menu tout de suite pour conserver l'ID du véhicule
    setOpenDeleteDialog(true);
  };
  
  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    // Fermer le menu contextuel seulement après la suppression
    handleMenuClose();
  };
  
  const handleOpenBulkDeleteDialog = () => {
    if (groupAction === 'delete' && selected.length > 0) {
      setOpenBulkDeleteDialog(true);
    }
  };
  
  const handleCloseBulkDeleteDialog = () => {
    setOpenBulkDeleteDialog(false);
  };
  
  const handleOpenUpd = (vehicleId) => {
    // Trouver le véhicule correspondant pour obtenir l'ID original
    const vehicle = rows.find(row => row.id === vehicleId);
    
    if (!vehicle) {
      console.error(`Error: Vehicle with ID ${vehicleId} not found in rows`);
      handleSnack("Erreur: Véhicule non trouvé", 'error');
      return;
    }
    
    // Utiliser l'ID original pour l'API si disponible, sinon utiliser l'ID de la ligne
    const apiId = vehicle.originalId || vehicle.id;
    
    setSelectedVehicleId(apiId);
    setOpenUpd(true);
  };
  
  const handleCloseUpd = () => {
    setOpenUpd(false);
    setSelectedVehicleId(null);
  };




  const [snack, setSnack] = useState({ open: false, message: '', type: 'success' });
  const handleSnack = (message, type = 'success') => {
    setSnack({ open: true, message, type });
  };
  
  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnack({ ...snack, open: false });
  };

  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [menuRowId, setMenuRowId] = useState(null);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  
  // State for selected rows/checkboxes
  const [selected, setSelected] = useState([]);
  const [groupAction, setGroupAction] = useState('');
  
  // Search filters
  const [searchFilters, setSearchFilters] = useState({
    keyword: '',
    marque: '',
    modele: '',
    type: '',
    enService: false
  });
  
  // Reset page to 1 when filters change
  useEffect(() => {
    setPage(1);
  }, [searchFilters]);
  // Fetch vehicles when component mounts
  useEffect(() => {
    fetchVehicles();
  }, []);

  const fetchVehicles = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get('/vehicles');
      setVehicles(response.data);
    } catch (err) {
      console.error('Error fetching vehicles:', err);
      setError('Failed to load vehicles');
      // Use sample data as fallback
      setVehicles([
        { id: 1, immatriculation: "AB-123-CD", marque: "Toyota", modele: "Corolla", places: 5, type: "Berline", chauffeur: "Jean Dupont", enService: "Oui" },
        { id: 2, immatriculation: "EF-456-GH", marque: "Mercedes", modele: "Sprinter", places: 12, type: "Minibus", chauffeur: "Marie Curie", enService: "Non" },
        { id: 3, immatriculation: "IJ-789-KL", marque: "Peugeot", modele: "308", places: 5, type: "Berline", chauffeur: "Paul Martin", enService: "Oui" },
        { id: 4, immatriculation: "MN-012-OP", marque: "Renault", modele: "Master", places: 9, type: "Van", chauffeur: "Sophie Bernard", enService: "Non" },
      ]);
    } finally {
      setLoading(false);
    }
  };
  
  // State for vehicle models and brands
  const [vehicleModelsMap, setVehicleModelsMap] = useState({});
  const [marques, setMarques] = useState([]);
  const [loadingModels, setLoadingModels] = useState(false);
  const [loadingMarques, setLoadingMarques] = useState(false);
  
  // Fetch vehicle models and marques when component mounts
  useEffect(() => {
    fetchVehicleModels();
    fetchMarques();
  }, []);
  
  // Fetch all marques directly from the API
  const fetchMarques = async () => {
    setLoadingMarques(true);
    try {
      const response = await api.get('/marques');
      setMarques(response.data);
    } catch (err) {
      console.error('Error fetching marques:', err);
      setMarques([]); // Set empty array as fallback
    } finally {
      setLoadingMarques(false);
    }
  };
  
  // Fetch all vehicle models
  const fetchVehicleModels = async () => {
    setLoadingModels(true);
    try {
      const response = await api.get('/vehicle-models');
      const modelsMap = {};
      
      // Create a map of model ID to model details including brand
      response.data.forEach(model => {
        modelsMap[model.ID_Model] = {
          id: model.ID_Model,
          name: model.name,
          marque: model.marque?.name || 'N/A',
          marqueId: model.ID_Marque
        };
      });
      
      setVehicleModelsMap(modelsMap);
    } catch (err) {
      console.error('Error fetching vehicle models:', err);
    } finally {
      setLoadingModels(false);
    }
  };
  
  // Map API response to table rows format
  // This implementation fixes the issue with accessing vehicle brand (marque) information
  // by using the vehicleModelsMap lookup instead of trying to access vehicle.model?.marque?.name directly
  const rows = vehicles.map((vehicle, index) => {
    // Get the model ID from the vehicle and look up its details in our map
    const modelId = vehicle.ID_Model;
    const modelDetails = vehicleModelsMap[modelId] || {};
    
    // Ensure we always have a valid ID for each row
    // First try to use the API's ID fields, then fallback to a generated ID based on index
    const vehicleId = vehicle.ID_Vehicle || vehicle.id || `temp-id-${index}`;
    
    // Log warning if we had to generate a temporary ID
    if (!vehicle.ID_Vehicle && !vehicle.id) {
      console.warn(`Warning: Vehicle at index ${index} has no ID, using generated ID: ${vehicleId}`);
    }
    
    return {
      id: vehicleId,
      originalId: vehicle.ID_Vehicle || vehicle.id, // Keep the original ID for API operations
      immatriculation: vehicle.immatriculation || 'N/A',
      // Use the marque from our lookup map instead of trying to access it directly
      marque: modelDetails.marque || 'N/A',
      // Use the model name from our lookup map or fallback to direct access
      modele: modelDetails.name || vehicle.model?.name || 'N/A',
      places: vehicle.seats || vehicle.places || 'N/A',
      type: vehicle.type || 'N/A',
      chauffeur: vehicle.user?.name || vehicle.chauffeur || 'N/A',
      // Map en_service boolean to "Oui"/"Non" for display
      enService: vehicle.en_service ? "Oui" : "Non"
    };
  });
  
  

  const handleDelete = async () => {
    // Stocker l'ID localement pour éviter qu'il ne soit perdu si le menu se ferme
    const vehicleId = menuRowId;
    
    try {
      // Vérifier que l'ID est valide
      if (!vehicleId) {
        console.error('Error: Vehicle ID is null or undefined');
        handleSnack("Erreur: ID du véhicule non valide", 'error');
        handleCloseDeleteDialog();
        return;
      }
      
      // Trouver le véhicule correspondant pour obtenir l'ID original
      const vehicle = rows.find(row => row.id === vehicleId);
      
      if (!vehicle) {
        console.error(`Error: Vehicle with ID ${vehicleId} not found in rows`);
        handleSnack("Erreur: Véhicule non trouvé", 'error');
        handleCloseDeleteDialog();
        return;
      }
      
      // Utiliser l'ID original pour l'appel API si disponible, sinon utiliser l'ID de la ligne
      const apiId = vehicle.originalId || vehicle.id;
      
      if (!apiId) {
        console.error(`Error: No valid API ID for vehicle ${vehicleId}`);
        handleSnack("Erreur: ID API du véhicule non valide", 'error');
        handleCloseDeleteDialog();
        return;
      }
      
      // Delete the vehicle with the original ID
      const response = await api.delete(`/vehicles/${apiId}`);
      // Refresh the vehicles list
      fetchVehicles();
      handleSnack('Véhicule supprimé avec succès', 'success');
      handleCloseDeleteDialog();
    } catch (error) {
      console.error('Error deleting vehicle:', error);
      
      // Gestion détaillée des erreurs
      if (error.response) {
        // La requête a été faite et le serveur a répondu avec un code d'état
        // qui ne fait pas partie de la plage 2xx
        const status = error.response.status;
        
        if (status === 404) {
          handleSnack("Erreur: Véhicule non trouvé ou déjà supprimé", 'error');
        } else if (status === 403) {
          handleSnack("Erreur: Vous n'avez pas les droits pour supprimer ce véhicule", 'error');
        } else if (status === 500) {
          handleSnack("Erreur serveur: Impossible de supprimer le véhicule", 'error');
        } else {
          handleSnack(`Erreur (${status}): ${error.response.data?.message || 'Erreur lors de la suppression du véhicule'}`, 'error');
        }
      } else if (error.request) {
        // La requête a été faite mais aucune réponse n'a été reçue
        handleSnack("Erreur réseau: Aucune réponse du serveur", 'error');
      } else {
        // Une erreur s'est produite lors de la configuration de la requête
        handleSnack("Erreur lors de la suppression du véhicule", 'error');
      }
      
      handleCloseDeleteDialog();
    }
  };

  const handleModify = () => {
    try {
      // Modify logic would go here
      handleSnack('Réservation modifiée avec succès', 'success');
      handleMenuClose();
    } catch (error) {
      handleSnack("Erreur lors de la modification de la réservation", 'error');
    }
  };

  const handleMenuClick = (event, id) => {
    // Vérifier que l'ID est valide avant de l'utiliser
    if (id) {
      setAnchorEl(event.currentTarget);
      setMenuRowId(id);
    } else {
      console.error('Error: Attempted to open menu with null or undefined ID');
      // Ne pas ouvrir le menu si l'ID est invalide
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(1);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map(n => n.id);
      setSelected(newSelected);
    } else {
      setSelected([]);
    }
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    
    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleGroupAction = () => {
    if (groupAction === 'delete' && selected.length > 0) {
      handleOpenBulkDeleteDialog();
    }
  };
  
  const handleBulkDelete = async () => {
    // Stocker les IDs localement pour éviter qu'ils ne soient perdus
    const vehicleIds = [...selected];
    
    try {
      // Vérifier que les IDs sont valides
      if (!vehicleIds.length) {
        console.error('Error: No vehicles selected for deletion');
        handleSnack("Erreur: Aucun véhicule sélectionné pour la suppression", 'error');
        handleCloseBulkDeleteDialog();
        return;
      }
      
      // Filtrer les IDs null ou undefined
      const validIds = vehicleIds.filter(id => id);
      
      if (validIds.length !== vehicleIds.length) {
        console.warn(`Warning: ${vehicleIds.length - validIds.length} invalid IDs were filtered out`);
      }
      
      if (validIds.length === 0) {
        console.error('Error: All selected vehicle IDs are invalid');
        handleSnack("Erreur: Tous les IDs de véhicules sélectionnés sont invalides", 'error');
        handleCloseBulkDeleteDialog();
        return;
      }
      
      // Mapper les IDs de ligne aux IDs originaux pour l'API
      const apiIds = validIds.map(id => {
        const vehicle = rows.find(row => row.id === id);
        return vehicle ? (vehicle.originalId || vehicle.id) : null;
      }).filter(id => id); // Filtrer les IDs null
      
      if (apiIds.length === 0) {
        console.error('Error: No valid API IDs found for selected vehicles');
        handleSnack("Erreur: Aucun ID API valide trouvé pour les véhicules sélectionnés", 'error');
        handleCloseBulkDeleteDialog();
        return;
      }
      
      if (apiIds.length !== validIds.length) {
        console.warn(`Warning: Only ${apiIds.length} out of ${validIds.length} selected vehicles have valid API IDs`);
      }
      
      // Delete all selected vehicles with valid API IDs using Promise.allSettled
      // pour gérer les succès et les échecs individuellement
      const deletePromises = apiIds.map(id => api.delete(`/vehicles/${id}`));
      const results = await Promise.allSettled(deletePromises);
      
      // Compter les succès et les échecs
      const successCount = results.filter(result => result.status === 'fulfilled').length;
      const failureCount = results.filter(result => result.status === 'rejected').length;
      
      // Refresh the vehicles list
      fetchVehicles();
      
      // Message adapté en fonction des résultats
      if (successCount > 0 && failureCount === 0) {
        handleSnack(`${successCount} véhicule(s) supprimé(s) avec succès`, 'success');
      } else if (successCount > 0 && failureCount > 0) {
        handleSnack(`${successCount} véhicule(s) supprimé(s) avec succès, ${failureCount} échec(s)`, 'warning');
      } else {
        handleSnack(`Échec de la suppression des ${failureCount} véhicule(s)`, 'error');
      }
      
      setSelected([]);
      setGroupAction('');
      handleCloseBulkDeleteDialog();
    } catch (error) {
      console.error('Error deleting vehicles:', error);
      
      // Gestion détaillée des erreurs
      if (error.response) {
        // La requête a été faite et le serveur a répondu avec un code d'état
        // qui ne fait pas partie de la plage 2xx
        const status = error.response.status;
        
        if (status === 500) {
          handleSnack("Erreur serveur: Impossible de supprimer les véhicules", 'error');
        } else {
          handleSnack(`Erreur (${status}): ${error.response.data?.message || 'Erreur lors de la suppression des véhicules'}`, 'error');
        }
      } else if (error.request) {
        // La requête a été faite mais aucune réponse n'a été reçue
        handleSnack("Erreur réseau: Aucune réponse du serveur", 'error');
      } else {
        // Une erreur s'est produite lors de la configuration de la requête
        handleSnack("Erreur lors de la suppression des véhicules", 'error');
      }
      
      handleCloseBulkDeleteDialog();
    }
  };

  // Filter rows based on search criteria
  // This implements comprehensive filtering for all search criteria
  const filteredRows = rows.filter(row => {
    // Check if row matches all active filters
    // Searches across specific fields for partial matches with keyword
    const matchesKeyword = !searchFilters.keyword || 
      row.immatriculation.toLowerCase().includes(searchFilters.keyword.toLowerCase()) ||
      row.modele.toLowerCase().includes(searchFilters.keyword.toLowerCase()) ||
      row.chauffeur.toLowerCase().includes(searchFilters.keyword.toLowerCase()) ||
      row.marque.toLowerCase().includes(searchFilters.keyword.toLowerCase());
      
    // Apply marque (brand) filter - only if a specific brand is selected
    const matchesMarque = !searchFilters.marque || row.marque === searchFilters.marque;
    
    // Apply modele (model) filter - only if a specific model is selected
    const matchesModele = !searchFilters.modele || row.modele === searchFilters.modele;
    
    // Apply type filter (e.g., Essence, Diesel)
    const matchesType = !searchFilters.type || row.type === searchFilters.type;
    
    // Apply enService (in service) filter - checks if vehicle is in service
    const matchesEnService = !searchFilters.enService || row.enService === "Oui";
    
    // If all filters pass, include the row in results
    return matchesKeyword && matchesMarque && matchesModele && matchesType && matchesEnService;
  });
  
  const paginatedRows = filteredRows.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  const pageCount = Math.ceil(filteredRows.length / rowsPerPage);

  return (
    <Box>
      <Navbar />
      <Box p={2}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <LocalShippingIcon />
            <Typography variant="h6">VÉHICULES</Typography>
          </Box>
          <Box display="flex" gap={2}>
          <Button variant="outlined" sx={{
              color: 'red',
              borderColor: 'red',
              textTransform: 'none',
              '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
            }} startIcon={<InsertDriveFileIcon />}>Exporter</Button>
            <Button variant="outlined"
             onClick={handleOpenAdd}
            sx={{
              color: 'red',
              borderColor: 'red',
              textTransform: 'none',
              '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
            }} startIcon={<Add />}>Ajouter</Button>
          </Box>
        </Box>
          {/* Search Section */}
          <Paper variant="outlined" sx={{ mb: 3 }}>
          <Box display="flex" alignItems="center" gap={1} mb={1} mt={1} onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <Search />
            <Typography variant="h6" sx={{ flexGrow: 1 }}>RECHERCHER</Typography>
            <IconButton>{open ? <ExpandLess /> : <ExpandMore />}</IconButton>
          </Box>
        </Paper>

        <Collapse in={open}>
          <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
            <Box display="flex" gap={2} mb={2}>
            <TextField
                label="Mot cle"
                name="keyword"
                value={searchFilters.keyword}
                onChange={(e) => setSearchFilters(prev => ({ ...prev, keyword: e.target.value }))}
                InputLabelProps={{ shrink: true }}
                fullWidth size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' },
                  },
                  '& .MuiInputLabel-root': {
                    '&.Mui-focused': { color: 'red' },
                    '&:hover': { color: '#000' },
                  }
                }}
              />
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Marque</InputLabel>
                <Select 
                  label="Marque" 
                  disabled={loadingMarques}
                  value={searchFilters.marque}
                  onChange={(e) => setSearchFilters(prev => ({ ...prev, marque: e.target.value, modele: '' }))}
                >
                  <MenuItem value="">Tous</MenuItem>
                  {loadingMarques ? (
                    <MenuItem value="" disabled>Chargement...</MenuItem>
                  ) : (
                    // Use marques directly from the API
                    marques
                      .filter(marque => marque && marque.name)
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map(marque => (
                        <MenuItem key={marque.ID_Marque} value={marque.name}>{marque.name}</MenuItem>
                      ))
                  )}
                </Select>
              </FormControl>
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Modèle</InputLabel>
                <Select 
                  label="Modèle" 
                  disabled={loadingModels}
                  value={searchFilters.modele}
                  onChange={(e) => setSearchFilters(prev => ({ ...prev, modele: e.target.value }))}
                >
                  <MenuItem value="">Tous</MenuItem>
                  {loadingModels ? (
                    <MenuItem value="" disabled>Chargement...</MenuItem>
                  ) : (
                    // Filter models based on selected marque
                    Object.values(vehicleModelsMap)
                      .filter(model => {
                        // If no marque is selected, show all models
                        if (!searchFilters.marque) return true;
                        // Otherwise, filter by the selected marque
                        return model.marque === searchFilters.marque;
                      })
                      .filter(model => model.name)
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map(model => (
                        <MenuItem key={model.id} value={model.name}>{model.name}</MenuItem>
                      ))
                  )}
                </Select>
              </FormControl>
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Type</InputLabel>
                <Select 
                  label="Type"
                  value={searchFilters.type}
                  onChange={(e) => setSearchFilters(prev => ({ ...prev, type: e.target.value }))}
                >
                  <MenuItem value="">Tous</MenuItem>
                  <MenuItem value="Essence">Essence</MenuItem>
                  <MenuItem value="Diesel">Diesel</MenuItem>
                </Select>
              </FormControl>
            </Box>
               <FormControlLabel 
                mb={2} 
                control={
                  <Checkbox 
                    name="enService" 
                    checked={searchFilters.enService} 
                    onChange={(e) => setSearchFilters(prev => ({ ...prev, enService: e.target.checked }))} 
                    sx={{'&.MuiCheckbox-indeterminate': { color: '#000' },'&.Mui-checked': { color: '#000' },}} 
                  />
                } 
                label="En service?" 
              />

            <Box display="flex" justifyContent="space-between" gap={2}>
              <Button 
                variant="outlined" 
                onClick={() => setSearchFilters({
                  keyword: '',
                  marque: '',
                  modele: '',
                  type: '',
                  enService: false
                })}
                sx={{
                  color: 'red',
                  borderColor: 'red',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
                }}
              >
                Reset
              </Button>
              <Button 
                 variant="outlined" 
                 onClick={() => {
                   // Search is already happening automatically through the filter function
                   // This button is just for UX consistency
                   // We could add additional functionality here if needed
                   setOpen(false); // Close the search panel after search
                 }}
                 sx={{
                   color: 'red',
                   borderColor: 'red',
                   textTransform: 'none',
                   '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
                 }}
               >
                 Rechercher
               </Button>
            </Box>
          </Paper>
        </Collapse>


        {/* Bulk Actions */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" gap={2}>
            <Typography>Actions groupées</Typography>
            <FormControl size="small" sx={{
                minWidth: 150 ,
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
              <Select
                value={groupAction}
                onChange={(e) => setGroupAction(e.target.value)}
                displayEmpty
              >
                <MenuItem value="" disabled><em>Sélectionner</em></MenuItem>
                <MenuItem value="delete">Supprimer</MenuItem>
              </Select>
            </FormControl>
            <Button
              variant="contained"
              disabled={!groupAction || selected.length === 0}
              onClick={handleGroupAction}
              sx={{
                bgcolor: 'red',
                textTransform: 'none',
                '&:hover': { bgcolor: 'red' },
                '&.Mui-disabled': { bgcolor: '#f5f5f5', color: '#bdbdbd' }
              }}
            >
              Appliquer
            </Button>
          </Box>
          <Typography>{selected.length} sélectionnés / {rows.length} entrées</Typography>
        </Box>

        {/* Table */}
        <TableContainer component={Paper} variant="outlined">
            <Table>
                <TableHead>
                <TableRow>
                    <TableCell padding="checkbox">
                    <Checkbox
                        indeterminate={selected.length > 0 && selected.length < rows.length}
                        checked={rows.length > 0 && selected.length === rows.length}
                        onChange={handleSelectAll}
                        sx={{
                        '&.MuiCheckbox-indeterminate': { color: '#000' },
                        '&.Mui-checked': { color: '#000' },
                        }}
                    />
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Immatriculation</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Marque</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Modèle</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Places</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Chauffeur</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>En service?</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {loading || loadingModels ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center" sx={{ py: 3 }}>
                      <Typography>Chargement des véhicules...</Typography>
                    </TableCell>
                  </TableRow>
                ) : error ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center" sx={{ py: 3 }}>
                      <Typography color="error">{error}</Typography>
                      <Button 
                        variant="outlined" 
                        sx={{ mt: 1, color: 'red', borderColor: 'red' }}
                        onClick={fetchVehicles}
                      >
                        Réessayer
                      </Button>
                    </TableCell>
                  </TableRow>
                ) : rows.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center" sx={{ py: 3 }}>
                      <Typography>Aucun véhicule trouvé</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedRows.map((row) => {
                    const isItemSelected = isSelected(row.id);
                    return (
                    <TableRow key={row.id} hover selected={isItemSelected}>
                        <TableCell padding="checkbox">
                        <Checkbox
                            checked={isItemSelected}
                            onChange={(event) => handleSelectOne(event, row.id)}
                            sx={{
                            '&.MuiCheckbox-indeterminate': { color: '#000' },
                            '&.Mui-checked': { color: '#000' },
                            }}
                        />
                        </TableCell>
                        <TableCell>{row.immatriculation}</TableCell>
                        <TableCell>{row.marque}</TableCell>
                        <TableCell>{row.modele}</TableCell>
                        <TableCell>{row.places}</TableCell>
                        <TableCell>{row.type}</TableCell>
                        <TableCell>{row.chauffeur}</TableCell>
                        <TableCell>{row.enService}</TableCell>
                        <TableCell>
                        <IconButton onClick={(e) => handleMenuClick(e, row.id)}>
                            <MoreVert />
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={menuRowId === row.id && openMenu}
                            onClose={handleMenuClose}
                            PaperProps={{
                            sx: {
                                minWidth: '200px',
                                '& .MuiMenuItem-root': {
                                color: 'black',
                                '& .MuiListItemIcon-root': { color: 'black' },
                                '&:hover': {
                                    backgroundColor: 'red',
                                    color: 'white',
                                    '& .MuiListItemIcon-root': { color: 'white' },
                                },
                                },
                            },
                            }}
                        >
                            <MenuItem component={Link} to={`/details-vehicules/${row.originalId || row.id}`}>
                            <ListItemIcon><List fontSize="small" /></ListItemIcon>
                            <ListItemText>Détail</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={() => handleOpenUpd(row.id)}>
                            <ListItemIcon><Edit fontSize="small" /></ListItemIcon>
                            <ListItemText>Modifier</ListItemText>
                            </MenuItem>
                            <MenuItem sx={{ color: 'red' }} onClick={handleOpenHis}>
                            <ListItemIcon sx={{ color: 'red' }}><History fontSize="small" /></ListItemIcon>
                            <ListItemText>Historique</ListItemText>
                            </MenuItem>
                            <MenuItem sx={{ color: 'red' }} onClick={handleOpenDeleteDialog}>
                            <ListItemIcon sx={{ color: 'red' }}><DeleteIcon fontSize="small" /></ListItemIcon>
                            <ListItemText>Supprimer</ListItemText>
                            </MenuItem>
                        </Menu>
                        </TableCell>
                    </TableRow>
                    );
                  })
                )}
                </TableBody>
            </Table>
     </TableContainer>

        {/* Pagination */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
          <Typography>{rows.length} entrées</Typography>
          <Box display="flex" gap={2} alignItems="center">
            <FormControl size="small" sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: '#000' },
                '&.Mui-focused fieldset': { borderColor: 'red' },
              }
            }}>
              <Select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </FormControl>
            <Pagination
              count={pageCount}
              page={page}
              onChange={handleChangePage}
              variant="outlined"
              shape="rounded"
            />
          </Box>
        </Box>
      </Box>

      <Snackbar 
        open={snack.open} 
        autoHideDuration={3000} 
        onClose={handleCloseSnack} 
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert 
          onClose={handleCloseSnack} 
          severity={snack.type} 
          elevation={6} 
          variant="filled" 
          sx={{ width: '100%', bgcolor: snack.type === 'success' ? 'green' : 'red' }}
        >
          {snack.message}
        </MuiAlert>
      </Snackbar>

    <HistoriqueModal open={openhis} handleClose={handleCloseHis} />
    <AddModal 
      open={openadd} 
      handleClose={handleCloseAdd} 
      onSuccess={() => {
        fetchVehicles();
        handleSnack('Véhicule ajouté avec succès', 'success');
      }} 
    />
    <UpdateModal 
      open={openupd} 
      handleClose={handleCloseUpd} 
      vehicleId={selectedVehicleId}
      onSuccess={() => {
        fetchVehicles();
        handleSnack('Véhicule modifié avec succès', 'success');
      }} 
    />
    
    {/* Delete Confirmation Dialog */}
    <Dialog
      open={openDeleteDialog}
      onClose={handleCloseDeleteDialog}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle id="delete-dialog-title" sx={{ color: 'red' }}>
        Confirmer la suppression
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-dialog-description">
          Êtes-vous sûr de vouloir supprimer ce véhicule ? Cette action est irréversible.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDeleteDialog} sx={{ color: 'black' }}>
          Annuler
        </Button>
        <Button onClick={handleDelete} sx={{ color: 'red' }} autoFocus>
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
    
    {/* Bulk Delete Confirmation Dialog */}
    <Dialog
      open={openBulkDeleteDialog}
      onClose={handleCloseBulkDeleteDialog}
      aria-labelledby="bulk-delete-dialog-title"
      aria-describedby="bulk-delete-dialog-description"
    >
      <DialogTitle id="bulk-delete-dialog-title" sx={{ color: 'red' }}>
        Confirmer la suppression multiple
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="bulk-delete-dialog-description">
          Êtes-vous sûr de vouloir supprimer les {selected.length} véhicules sélectionnés ? Cette action est irréversible.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseBulkDeleteDialog} sx={{ color: 'black' }}>
          Annuler
        </Button>
        <Button onClick={handleBulkDelete} sx={{ color: 'red' }} autoFocus>
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
    </Box>
  );
}